<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner pb-12 pb-md-0"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>รวมโครงการ</span>

								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span v-if="content === 'singlehome'">
									บ้านเดี่ยว
								</span>
								<span v-else-if="content === 'townhome'">
									ทาวน์โฮม
								</span>
								<span v-else-if="content === 'condo'">
									คอนโด
								</span>
								<span v-else-if="content === 'shophouse'">
									อาคารพาณิชย์
								</span>
							</div>
							<div class="search-filter">
								<h1>รวมโครงการ</h1>

								<div class="pl-3 pr-5">
									<h2 v-if="content === 'singlehome'">
										บ้านเดี่ยว
									</h2>
									<h2 v-else-if="content === 'townhome'">
										ทาวน์โฮม
									</h2>
									<h2 v-else-if="content === 'condo'">
										คอนโด
									</h2>
									<h2 v-else-if="content === 'shophouse'">
										อาคารพาณิชย์
									</h2>
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div style="height: 300px;">
				<!-- <z-img
					:storage="bannerImg"
					max-width="100%"
					height="300"
				/> -->
				<v-container class="pa-0">
					<v-row
						class="justify-center"
						no-gutters
					>
						<v-col xl="9">
							<z-img
								:storage="bannerImg"
								height="300"
								class="left"
								style="position: absolute; width: 100%;"
							/>
						</v-col>
					</v-row>
				</v-container>
			</div>
		</div>

		<searchForm
			ref="searchComponent"
			class="float-tab"
			:tabs="null"
			:hide-text-search="false"
		/>

		<div>
			<v-container class="pa-00">
				<v-row no-gutters>
					<v-col
						xl="7"
						class="mx-auto pr-6 px-md-12 px-xl-0"
					>
						<div class="d-flex">
							<div class="px-4">
								<img
									:src="`/images/2.0/icon/${content}_i.png`"
									width="64"
								>
							</div>
							<div class="py-4">
								<template v-if="content === 'singlehome'">
									<h1 class="red--text">
										รวมอสังหา บ้านมือสอง บ้านเดี่ยว หมู่บ้านจัดสรร {{ thaiYear }} พร้อมอยู่ หลายทำเล
									</h1>
									<p class="mt-4">
										รับซื้อ-ขาย บ้านมือสอง บ้านเดี่ยวใจกลางเมือง คุ้มค่า คุ้มราคา รวมทุกทำเลทั้งกรุงเทพ ปริมณฑลและต่างจังหวัด มีทุกราคาในทำเลที่เดินทางสะดวก เหมาะกับคนหาบ้านมือสองพร้อมเข้าอยู่พร้อมโปรแกรมคำนวณสินเชื่อฟรี ส่วนใครอยากขายบ้านมือสอง แต่ไม่มีเวลา หาช่องทางโปรโมตไม่ได้ การฝากขายบ้านกับเราคือทางออกที่จะช่วยให้คุณซื้อ-ขายบ้านได้ง่าย ปิดการขายได้เร็ว ด้วยเทคนิคแบบเฉพาะของ The Best ลงขายได้เลยทันที
									</p>
								</template>

								<template v-else-if="content === 'townhome'">
									<h1 class="red--text">
										รวมอสังหาบ้าน ทาวน์โฮม ทาวน์เฮ้าส์ Townhome-Townhouse ซื้อ ขาย
									</h1>
									<p class="mt-4">
										รวมโครงการอสังหาบ้าน ทาวน์โฮม ทาวน์เฮ้าส์ ตั้งแต่ราคาไม่เกินล้าน ไปจนถึงราคาล้านต้นๆ ในทุกทำเล ตอบโจทย์ทุกไลฟ์สไตล์ในทุกโซนทั้งกรุงเทพมหานคร ปริมณฑล และต่างจังหวัด รวมมาให้ครบทุกทำเลดี มีสิ่งอำนวยความสะดวกครบครัน หากสนใจซื้อ-ขายบ้าน สามารถค้นหาตัวแทนเพื่อช่วยเหลือคุณได้ หมดปัญหาขายไม่ออก หรือการเจอบ้านสภาพไม่ดี เพราะที่นี่ช่วยดูแลให้ครบวงจร พร้อมมีโปรแกรมคำนวณสินเชื่อให้ฟรี
									</p>
								</template>

								<template v-else-if="content === 'condo'">
									<h1 class="red--text">
										รวมคอนโด คอนโดมิเนียม (Condo) ซื้อ ขาย คอนโดมือสอง พร้อมอยู่
									</h1>
									<p class="mt-4">
										รวมคอนโด (Condo) มือหนึ่ง มือสอง คอนโดพร้อมอยู่ ปี {{ thaiYear }} ทั้ง 1 ห้องนอน 2 ห้องนอน และ 3 ห้องนอนในราคาที่ดีที่สุด ในทำเลยอดฮิต ติดรถไฟฟ้า เดินทางสะดวก ในราคาที่คุณต้องการ พร้อมสิ่งอำนวยความสะดวกครบครัน อย่าลืมคำนวณสินเชื่อกับเราฟรี และใช้บริการซื้อขายคอนโดกับเรา ด้วยบริการแบบครบวงจรจากนายหน้ามากประสบการณ์ พร้อมปิดการขายอย่างรวดเร็ว ถูกใจทั้งฝั่งผู้ซื้อและผู้ขายที่ต้องการความสะดวกที่สุด
									</p>
								</template>

								<template v-else-if="content === 'shophouse'">
									<h1 class="red--text">
										รวมประกาศซื้อ ขาย ให้เช่า เซ้ง อาคารพาณิชย์ ตึกแถว ในกรุงเทพเเละต่างจังหวัด
									</h1>
									<p class="mt-4">
										รวมประกาศขายอาคารพาณิชย์ ทั้งในย่านใจกลางเมือง ปริมณฑล และต่างจังหวัดทุกทำเลยอดนิยม ใกล้แหล่งชุมชน เดินทางสะดวก เปิดโอกาสให้ทำกิจการรุ่งเรือง ในหลากหลายเรตราคาที่คุณต้องการ พร้อมมีโปรแกรมคำนวณสินเชื่อให้คุณคำนวณได้ก่อนฟรี นอกจากนี้เรายังมีบริการสำหรับผู้ที่ต้องการขายตึกแถวแบบครบวงจร ไม่ต้องทำการตลาดเอง ไม่ต้องออกหาลูกค้า ที่นี่พร้อมจัดหาให้ด้วยเทคนิคนายหน้าระดับมืออาชีพ และฐานผู้ซื้อจำนวนมากที่เราครอบครอง
									</p>
								</template>
							</div>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div>
			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col
						xl="8"
						class="mx-auto px-4 px-md-12"
					>
						<v-row>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: 'category-hub-singlehome'}"
								>
									<div class="home-cate-logo singlehome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">บ้านเดี่ยว</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: 'category-hub-townhome'}"
								>
									<div class="home-cate-logo townhome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">ทาวน์โฮม</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: 'category-hub-condo'}"
								>
									<div class="home-cate-logo condo" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">คอนโดมิเนียม</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: 'category-hub-shophouse'}"
								>
									<div class="home-cate-logo shophouse" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">อาคารพาณิชย์</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bg-red-red">
			<v-container class="pa-0">
				<v-row
					class="property-recommend justify-center"
					no-gutters
				>
					<v-col xl="8">
						<h2 class="text-center my-7">
							แนะนำ<span class="red--text">อสังหาริมทรัพย์ใหม่</span>
						</h2>

						<propertyCarousel
							white
							style="margin-bottom: 60px;"
							:query="{ market_selected, path: 'latest' }"
						/>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<!-- อสังหาบ้าน<span class="red--text">กรุงเทพ</span> -->
							<template v-if="content === 'singlehome'">
								<n-link :to="{ name: 'bangkok', params: { category: content } }">
									<span>บ้านมือสอง</span><span class="colorRed">กรุงเทพ</span>
								</n-link>
							</template>
							<template v-else-if="content === 'townhome'">
								<n-link :to="{ name: 'bangkok', params: { category: content } }">
									<span>อสังหาทาวน์โฮม</span><span class="colorRed">กรุงเทพ</span>
								</n-link>
							</template>
							<template v-else-if="content === 'condo'">
								<n-link :to="{ name: 'bangkok', params: { category: content } }">
									<span>อสังหาคอนโด</span><span class="colorRed">กรุงเทพ</span>
								</n-link>
							</template>
							<template v-else-if="content === 'shophouse'">
								<n-link :to="{ name: 'bangkok', params: { category: content } }">
									<span>อสังหาอาคารพาณิชย์</span><span class="colorRed">กรุงเทพ</span>
								</n-link>
							</template>
						</h2>

						<div class="mb-6">
							<v-slide-group show-arrows>
								<template #next>
									<v-icon color="rgb(237,28,36)">
										$next
									</v-icon>
								</template>
								<template #prev>
									<v-icon color="rgb(237,28,36)">
										$prev
									</v-icon>
								</template>

								<v-slide-item
									v-for="(a, i) in area('bangkok', content)"
									:key="`bangkok-${i}`"
								>
									<v-btn
										class="area mr-2 pa-2"
										elevation="0"
										text
										tile
										:to="a.path"
									>
										{{ a.text }}
									</v-btn>
								</v-slide-item>
							</v-slide-group>
						</div>

						<propertyCarousel :query="{ market_selected, province: 1 }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: 'bangkok', params: { category: content } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: 'bangkok', params: { category: content } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bgGray pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<template v-if="content === 'singlehome'">
								<n-link :to="{ name: 'samut-prakan', params: { category: content } }">
									<span>บ้านมือสอง</span><span class="colorRed">สมุทรปราการ</span>
								</n-link>
							</template>
							<template v-else-if="content === 'townhome'">
								<n-link :to="{ name: 'samut-prakan', params: { category: content } }">
									<span>อสังหาทาวน์โฮม</span><span class="colorRed">สมุทรปราการ</span>
								</n-link>
							</template>
							<template v-else-if="content === 'condo'">
								<n-link :to="{ name: 'samut-prakan', params: { category: content } }">
									<span>อสังหาคอนโด</span><span class="colorRed">สมุทรปราการ</span>
								</n-link>
							</template>
							<template v-else-if="content === 'shophouse'">
								<n-link :to="{ name: 'samut-prakan', params: { category: content } }">
									<span>อสังหาอาคารพาณิชย์</span><span class="colorRed">สมุทรปราการ</span>
								</n-link>
							</template>
						</h2>


						<div class="mb-6">
							<v-slide-group show-arrows>
								<template #next>
									<v-icon color="rgb(237,28,36)">
										$next
									</v-icon>
								</template>
								<template #prev>
									<v-icon color="rgb(237,28,36)">
										$prev
									</v-icon>
								</template>

								<v-slide-item
									v-for="(a, i) in area('samut-prakan', content)"
									:key="`samut-prakan-${i}`"
								>
									<v-btn
										class="area mr-2 pa-2"
										elevation="0"
										text
										tile
										:to="a.path"
									>
										{{ a.text }}
									</v-btn>
								</v-slide-item>
							</v-slide-group>
						</div>

						<propertyCarousel :query="{ market_selected, province: 2 }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: 'samut-prakan', params: { category: content } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: 'samut-prakan', params: { category: content } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<template v-if="content === 'singlehome'">
								<n-link :to="{ name: 'nonthaburi', params: { category: content } }">
									<span>บ้านมือสอง</span><span class="colorRed">นนทบุรี</span>
								</n-link>
							</template>
							<template v-else-if="content === 'townhome'">
								<n-link :to="{ name: 'nonthaburi', params: { category: content } }">
									<span>อสังหาทาวน์โฮม</span><span class="colorRed">นนทบุรี</span>
								</n-link>
							</template>
							<template v-else-if="content === 'condo'">
								<n-link :to="{ name: 'nonthaburi', params: { category: content } }">
									<span>อสังหาคอนโด</span><span class="colorRed">นนทบุรี</span>
								</n-link>
							</template>
							<template v-else-if="content === 'shophouse'">
								<n-link :to="{ name: 'nonthaburi', params: { category: content } }">
									<span>อสังหาอาคารพาณิชย์</span><span class="colorRed">นนทบุรี</span>
								</n-link>
							</template>
						</h2>

						<propertyCarousel :query="{ market_selected, province: 3 }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: 'nonthaburi', params: { category: content } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: 'nonthaburi', params: { category: content } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bgGray pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<template v-if="content === 'singlehome'">
								<n-link :to="{ name: 'chonburi', params: { category: content } }">
									<span>บ้านมือสอง</span><span class="colorRed">ชลบุรี</span>
								</n-link>
							</template>
							<template v-else-if="content === 'townhome'">
								<n-link :to="{ name: 'chonburi', params: { category: content } }">
									<span>อสังหาทาวน์โฮม</span><span class="colorRed">ชลบุรี</span>
								</n-link>
							</template>
							<template v-else-if="content === 'condo'">
								<n-link :to="{ name: 'chonburi', params: { category: content } }">
									<span>อสังหาคอนโด</span><span class="colorRed">ชลบุรี</span>
								</n-link>
							</template>
							<template v-else-if="content === 'shophouse'">
								<n-link :to="{ name: 'chonburi', params: { category: content } }">
									<span>อสังหาอาคารพาณิชย์</span><span class="colorRed">ชลบุรี</span>
								</n-link>
							</template>
						</h2>

						<propertyCarousel :query="{ market_selected, province: 11 }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: 'chonburi', params: { category: content } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: 'chonburi', params: { category: content } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div>
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						cols="12"
						md="10"
						xl="7"
						class="mx-autos my-8 px-4"
					>
						<template v-if="content === 'singlehome'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								อสังหาฯโครงการบ้านเดี่ยว บ้านมือสอง พร้อมอยู่
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ใครที่หาซื้อบ้านมือสอง แล้วสนใจโครงการอสังหาบ้านเดี่ยว ไม่ว่าจะเป็นบ้านเดี่ยวชั้นเดียว บ้านเดี่ยว 2 ชั้น อยากซื้อ-ขายบ้านมือสอง บ้านพร้อมที่ดิน และต้องการบ้านตกแต่งพร้อมอยู่ในทุกทำเลทั้งกรุงเทพ ปริมณฑล และต่างจังหวัด ที่นี่รวบรวมประกาศขาย บ้านมือสอง บ้านเดี่ยว อสังหาใหม่ๆ บ้านเดี่ยวราคาถูก บ้านเดี่ยวกรุงเทพ โครงการอสังหาบ้านจัดสรร บ้านมือสอง ในช่วงหลากหลายราคา เช่น อสังหาบ้านเดี่ยวราคาไม่เกิน 1.5 ล้าน, ราคาไม่เกิน 2 ล้าน, ราคาไม่เกิน 3 ล้าน ไปจนถึงบ้านเดี่ยวราคา 10 ล้านขึ้นไป
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2">
												ทั้งหมดล้วนเป็นบ้านมือสองใหม่ที่เดินทางสะดวก ใกล้รถไฟฟ้า ใกล้ทางด่วน และยังมีหลากหลายสไตล์ให้เลือก หลากหลายขนาดทั้งบ้าน 100 ตารางวา, บ้าน 200 ตารางวา, บ้าน 300 ตารางวา, บ้าน 400 ตารางวา จัดเต็มในพื้นที่ส่วนกลาง ให้คุณพักผ่อนได้อย่างเต็มที่ทั้งในบ้านและนอกบ้านกับอสังหาบ้านเดี่ยว บ้านมือสอง ที่คัดสรรมาแล้วว่าคุ้มที่สุด
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								บ้านมือสอง ซื้อแล้วดีอย่างไร
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									บ้านมือสอง คือการซื้อความคุ้มค่า
								</h3>
								<p class="mt-2">
									การซื้อ-ขายบ้านมือสอง เป็นการซื้อบ้านพร้อมอยู่ ได้บ้านพร้อมที่ดิน ทำให้มีความเป็นส่วนตัว สงบ ปลอดภัย แถมยังมีสิ่งอำนวยความสะดวกทั้งในบ้านและในโครงการอสังหาครบ ทำให้การอยู่บ้านเป็นเหมือนการพักผ่อนไปในตัว ซึ่งเป็นความคุ้มค่าที่บ้านประเภทอื่นอาจให้ไม่ได้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												บ้านมือสอง มีหลากหลายราคาให้เลือกสรร
											</h3>
											<p class="mt-2">
												แบรนด์บ้านมือสองแบบบ้านเดี่ยวมีให้เลือกตั้งแต่ราคาล้านต้นๆ ไปจนถึงราคา 50 ล้านบาทขึ้นไปแตกต่างกันที่ขนาด ทำเล รูปแบบอสังหา ซึ่งคุณสามารถเลือกบ้านมือสองให้ตอบโจทย์กับการใช้ชีวิตของตัวเองและครอบครัวของคุณได้ รวมถึงตอบโจทย์งบในกระเป๋าได้ดีอีกด้วย
											</p>

											<h3 class="mt-3">
												บ้านมือสอง มักอยู่ในทำเลเดินทางสะดวก
											</h3>
											<p class="mt-2">
												เพราะบ้านเดี่ยวมักใช้พื้นที่ในการสร้างเยอะ จึงทำให้เป็นทำเลของการใช้รถใช้ถนนเป็นหลัก จึงต้องเดินทางสะดวก อีกทั้งหลายโครงการอสังหาบ้านเดี่ยวยังอยู่ใกล้รถไฟฟ้า ทำให้การคมนาคมและการใช้ชีวิตเป็นไปอย่างรวดเร็ว สมกับการลงทุนซื้อบ้านมือสองในย่านใจกลางเมืองเอาไว้ในครอบครอง
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาอสังหา บ้านเดี่ยว บ้านมือสอง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									หากคุณกำลังมองหาและกำลังพิจารณาราคาบ้านมือสอง ซึ่งมีให้เลือกตั้งแต่ราคาล้านต้นๆ ไปจนถึงราคา 50 ล้านบาท ลองตัดสินใจจากแนวโน้มของราคาบ้านเดี่ยว บ้านมือสอง ตามทำเลต่างๆ ดังนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul>
												<li>บ้านเดี่ยว บ้านมือสอง โซนกรุงเทพมหานครยังคงมีแนวโน้มเพิ่มขึ้นต่อเนื่อง เฉลี่ยอยู่ที่ร้อยละ 16 เพราะคนให้ความสำคัญกับเรื่องของความเป็นส่วนตัวมากขึ้น โดยในปี {{ thaiYear }} นี้ ทำเลที่อยู่ใกล้กับแนวรถไฟฟ้าทั้งสายใหม่และสายเก่า จะเป็นทำเลที่คนสนใจ เช่น ย่านรังสิต-นวนคร, ศรีนครินทร์-สุวรรณภูมิ, อ่อนนุช-บางนา, ดอนเมือง-พหลโยธิน เป็นต้น</li>
												<li>บ้านมือสองโซนสมุทรปราการ มีแนวโน้มราคาสูงขึ้นเรื่อยๆ เพราะเดินทางสะดวก เข้าเมืองได้ง่าย ประกอบกับแนวโน้มทางด้านราคาที่ดินตั้งแต่ปี 2561-2562 ที่ปรับตัวมากกว่า 50-60% โดยเฉพาะบ้านมือสองโซนบางนาจะได้รับความนิยมมากเป็นพิเศษ</li>
												<li>บ้านมือสองโซนชลบุรี คนนิยมซื้อและเช่าเพื่อเป็นบ้านพัก/บ้านหลังที่สอง หรือเพื่อลงทุน รวมถึงยังเป็นที่อยู่อาศัยของชาวต่างชาติที่ Expat ทำงานอยู่แถบชายฝั่งของไทย ทำให้มีราคาอสังหาฯ ปรับตัวสูงขึ้นเรื่อยๆ โดยในปี {{ thaiYear }} นี้คาดว่าภาพรวมของอสังหาฯ บ้านมือสองในย่านนี้มูลค่าจะเพิ่มขึ้นร้อยละ 29.0</li>
												<li>บ้านมือสองโซนนนทบุรี จะมีราคาที่อยู่อาศัยค่อนข้างสูงเมื่อเทียบกับจังหวัดอื่น โดยมีราคาต่ำกว่ากรุงเทพฯ ประมาณ 30-50% เนื่องจากการเดินทางที่สะดวกสบาย มีถนนเชื่อมต่อกับกรุงเทพฯ และ จ.ปทุมธานีในหลายๆ พื้นที่ และเริ่มมีแหล่งงานใหม่ๆ เพิ่มมากขึ้นด้วย</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-4">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกซื้ออสังหา บ้านเดี่ยว บ้านมือสอง
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ทำเลที่อยู่อาศัย การเลือกซื้ออสังหาบ้านมือสอง
								</h3>
								<p class="mt-2 mb-0">
									หากกำลังหาบ้านมือสองและที่ดิน หรือบ้านหรูในลักษณะบ้านเดี่ยว ก็ควรที่จะให้ความสำคัญกับ ‘ทำเล’ โดยควรดูว่า ทำเลของโครงการอสังหาหมู่บ้านที่เลือกนั้นตรงกับกฎเกณฑ์เหล่านี้หรือไม่
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul class="mt-2 mb-0">
												<li>เป็นทำเลใกล้ที่ทำงาน</li>
												<li>เป็นที่อยู่ใกล้โรงเรียนของลูก ใกล้ขนส่งสาธารณะ ใกล้สิ่งอำนวยความสะดวก โรงพยาบาล ห้างสรรพสินค้า</li>
												<li>เป็นทำในพื้นที่ๆ คุ้นเคย (เช่นคนที่เคยอยู่แถวบางนามาก่อน ก็มีแนวโน้มที่จะซื้อย่านบางนาอีกครั้งเพราะความคุ้นเคย)</li>
												<li>เป็นสำหรับนักลงทุนอาจจะมองถึงทำเลที่มีศักยภาพ ราคาเติบโตในอนาคต</li>
											</ul>
											<p class="mt-2">
												หากคำตอบคือ ‘ใช่’ ทำเลของโครงการอสังหาบ้านมือสองนั้นก็จะสามารถตอบโจทย์การใช้ชีวิตของคุณได้ครบอย่างแน่นอน
											</p>
											<h3 class="mt-2">
												การเดินทางของโครงการบ้านเดี่ยว บ้านมือสอง ในโซนต่างๆ
											</h3>
											<ul class="mt-2 mb-0">
												<li>บ้านมือสองโซนกรุงเทพมหานคร เป็นโซนย่านธุรกิจ ซึ่งบริเวณใจกลางเมืองจะมี MRT สายสีน้ำเงิน และ BTS สายสีเขียวเป็นจุดการเดินทางสำคัญ โดยสถานีที่มีทั้งคนทำงานและคนอยู่อาศัยเยอะ เช่น MRT พระราม 9, BTS สุขุมวิท, MRT ลาดพร้าว, BTS จตุจักร, BTS วงเวียนใหญ่ เป็นต้น รวมไปถึงรถไฟฟ้าเส้นใหม่ก็เปิดตัวให้บริการอย่างต่อเนื่อง เช่น สายสีแดง สายสีชมพู สายสีเหลือง สายสีส้ม กรุงเทพฯ จึงเป็น HUB ที่อยู่อาศัยที่คนเลือกจะซื้อบ้านมือสองมากที่สุด</li>
												<li>บ้านมือสองโซนสมุทรปราการ โดดเด่นในเรื่องของเส้นทางการเดินทางเข้า-ออกเมือง มีถนนตัดผ่านหลายสาย มีทางด่วนหลายจุด และยังเชื่อมต่อไปยังจังหวัดชลบุรีได้ อีกทั้งยังมีรถไฟฟ้าตัดผ่าน ตั้งแต่สถานีบางนา สถานีแบริ่ง สถานีสำโรง สถานีปู่เจ้าสมิงพราย สถานีช้างเอราวัณ สถานีโรงเรียนนายเรือ สถานีปากน้ำ สถานีศรีนครินทร์ สถานีแพรกษา สถานีสายลวด จนปัจจุบันมีถึงสถานีการเคหะฯ ส่วนในอนาคตมีแผนการจะขยายไปจนถึงสถานีบางปูเลยทีเดียว</li>
												<li>บ้านมือสองโซนชลบุรี แถบชลบุรีเป็นเมืองที่มีระบบการคมนาคมขนส่งทั่วถึง และสะดวกในทุกด้าน ทั้งการขนส่งทางบก ทางเรือ และทางอากาศ เพราะเป็นเมืองท่าที่สำคัญจัดอยู่ในเขตพัฒนาพิเศษภาคตะวันออก (EEC) ทำให้มีแผนการพัฒนาอย่างต่อเนื่อง และในอนาคตก็ยังมีแผนการสร้างรถไฟความเร็วสูง เชื่อม 3 สนามบิน จากสนามบินดอนเมือง ผ่านสถานีบางซื่อ สถานีพญาไท สถานีราชปรารภ สถานีมักกะสัน สถานีรามคำแหง สถานีหัวหมาก สถานีบ้านทับช้าง สถานีลาดกระบัง ผ่านสนามบินสุวรรณภูมิ ไปยังสถานีฉะเชิงเทรา สถานีชลบุรี สถานีศรีราชา และไปสิ้นสุดที่สถานีอู่ตะเภา</li>
												<li>บ้านมือสองโซนนนทบุรี เป็นอีกหนึ่งจังหวัดในกรุงเทพฯ จึงมีเส้นทางการคมนาคมที่สะดวก เชื่อมต่อเข้ากับถนนสายหลักหลากหลายสาย อาทิ ถนนราชพฤกษ์, ถนนรัตนาธิเบศร์, ถนนงามวงศ์วาน, ถนนพิบูลสงคราม เป็นต้น และยังมีรถไฟฟ้าสายสีม่วงตัดผ่าน ได้แก่ สถานีเตาปูน สถานีบางซ่อน สถานีวงศ์สว่าง สถานีแยกติวานนท์ สถานีกระทรวงสาธารณสุข สถานีศูนย์ราชการนนทบุรี สถานีบางกระสอ สถานีแยกนนทบุรี 1 สถานีสะพานพระนั่งเกล้า สถานีแยกนนทบุรี สถานีไทรม้า สถานีบางรักน้อยท่าอิฐ สถานีบางรักใหญ่ สถานีบางพลู สถานีสามแยกบางใหญ่ สถานีตลาดบางใหญ่ และสถานีคลองบางไผ่</li>
											</ul>
											<h3 class="mt-2">
												สถานที่ท่องเที่ยว โครงการบ้านมือสองในโซนต่างๆ
											</h3>
											<ul class="mt-2 mb-0">
												<li>โซนกรุงเทพมหานคร เป็นโซนที่เต็มไปด้วยสีสันและความเจริญ จึงมีทั้งคาเฟ่ ห้างสรรพสินค้า แหล่งจับจ่ายซื้อสอยมากมาย หรือถ้าใครชอบเดินสวนสาธารณะก็มีสวนใจกลางเมืองหลายแห่ง มีร้านอาหารชื่อดังรายล้อมรอบๆ สถานีรถไฟฟ้าแต่ละแห่ง เรียกได้ว่า อยู่ในโซนนี้รับรองว่า ไม่มีเบื่อแน่นอน</li>
												<li>โซนสมุทรปราการ จะเป็นโซนอนุรักษ์ มีทั้งแนวธรรมชาติ เช่น บางกระเจ้า สถานีตากอากาศบางปู หรือจะไปเที่ยวแนวประวัติศาสตร์ วัฒนธรรมก็จะมีเมืองโบราณ สมุทรปราการ พิพิธภัณฑ์ช้างเอราวัณ วัดอโศการาม เป็นต้น ซึ่งส่วนใหญ่จะเป็นสถานที่ให้ความสงบ เหมาะกับการพักผ่อนหย่อนใจ</li>
												<li>โซนชลบุรี ขึ้นชื่อเรื่องของทะเลไม่ว่าจะเป็น ทะเลชะอำ ทะเลศรีราชา ทะเลบางแสน หรือถ้าว่างๆ ก็สามารถนั่งเรือข้ามไปยังเกาะศรีชังได้ นอกจากนี้ยังขึ้นชื่อเรื่องร้านอาหารทะเลและสะพานปลา ถ้าอยากกินอาหารทะเลอร่อยๆ แบบสดๆ ก็ต้องมาที่จังหวัดชลบุรีเลย</li>
												<li>โซนนนทบุรี เมืองแนววินเทจเต็มไปด้วยแหล่งท่องเที่ยวสไตล์ย้อนวันวาน เช่น ท่าน้ำนนท์ เกาะเกร็ด ตลาดนกฮูก ศาลากลางจังหวัดนนทบุรี (หลังเก่า) วัดบรมราชากาญจนาภิเษกอนุสรณ์ (วัดเล่งเน่ยยี่2) ตลาดน้ำวัดตะเคียน เป็นต้น</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<template v-else-if="content === 'townhome'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								รวมอสังหา บ้าน ทาวน์โฮม ทาวน์เฮ้าส์ บ้านพร้อมอยู่
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									รวมอสังหาบ้านทาวน์โฮมราคาถูก บ้านทาวน์เฮ้าส์ราคาถูก หรือใครที่กำลังหาบ้านทาวน์โฮม ทาวน์เฮ้าส์ มือสอง หรือโครงการอสังหาใหม่ ทั้งแบบ 2 ห้องนอน 3 ห้องนอน 4 ห้องนอน หรือ 5 ห้องนอน ต้องการซื้อ-ขายบ้านทาวน์เฮ้าส์ทั้งในพื้นที่กรุงเทพฯ ปริมณฑลและต่างจังหวัด ในเส้นทางที่เดินทางสะดวก ใกล้ทางด่วน ใกล้รถไฟฟ้า ใกล้แหล่งจับจ่ายใช้สอย
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2">
												ที่นี่รวบรวมบ้านทาวน์เฮ้าส์และทาวน์โฮมในหลากหลายราคา หลากหลายสไตล์ ตอบโจทย์ความต้องการของคุณและทุกคนในครอบครัว ค้นหาเจอได้ในทุกทำเลทั้งทาวน์โฮม ทาวน์เฮ้าส์ บ้านพร้อมอยู่โซนกรุงเทพมหานคร โซนชลบุรี โซนสมุทรปราการ โซนนนทบุรี ฝั่งธนบุรี หรือจังหวัดหัวเมืองอื่นๆ ซึ่งเป็นที่นิยม
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ซื้อ บ้าน ทาวน์โฮม ทาวน์เฮ้าส์ ดีอย่างไร
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ตกแต่งร่วมสมัยไม่มีเก่า
								</h3>
								<p class="mt-2">
									อสังหาประเภทบ้านทาวน์โฮมมักมีการออกแบบตกแต่งที่สวยงามร่วมสมัย การเพิ่มฟังก์ชันการใช้สอยพื้นที่อย่างคุ้มค่าทั้งในแบบทาวน์เฮ้าส์ชั้นเดียว ทาวน์เฮ้าส์ 2 ชั้น ทาวน์โฮม 2 ชั้น ทาวน์เฮ้าส์ 3 ชั้น รวมถึงการวางผังภายในได้ตอบไลฟ์สไตล์ของผู้อยู่อาศัยได้ครบถ้วน เช่น มีสวนหลังบ้าน มีห้องครัว ห้องทำงาน ห้องนอน ห้องน้ำ
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ราคาจับต้องได้ในทำเลทอง
											</h3>
											<p class="mt-2">
												คุณสามารถเป็นเจ้าของบ้านทาวน์โฮม บ้านทาวน์เฮ้าส์ในราคาที่จับต้องได้ตั้งแต่ราคาไม่เกินล้าน ไปจนถึงราคาไม่เกิน 4 ล้านในทำเลทองที่เป็นที่ต้องการทั้งของผู้ซื้ออยู่เองหรือนักลงทุน เนื่องจากเป็นทำเลที่เดินทางสะดวก ทั้งการใช้รถใช้ถนนหรือการใช้รถไฟฟ้าเป็นหลัก
											</p>

											<h3 class="mt-3">
												สิ่งอำนวยความสะดวกครบครัน
											</h3>
											<p class="mt-2">
												บ้านทาวน์โฮม บ้านทาวน์เฮ้าส์ มาพร้อมกับพื้นที่ส่วนกลางที่ดีไซน์ให้ใกล้เคียงกันโครงการอสังหาประเภทบ้านเดี่ยว แต่ให้ความรู้สึกอบอุ่นด้วยขนาดที่กะทัดรัดกว่า บางโครงการอสังหามีเทคโนโลยีต่าง ๆ ที่ช่วยดำเนินชีวิตในบ้าน นอกจากนี้คนยังนิยมซื้อทาวน์โฮมและทาวน์เฮ้าส์เพื่อทำเป็นโฮมออฟฟิศได้อีกด้วย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาโครง ทาวน์โฮม ทาวน์เฮ้าส์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									รวมราคาของทาวน์โฮมหรู ทาวน์โฮมพร้อมอยู่ ราคาไม่เกิน 8 แสน ไปจนถึง 4 ล้านบาทขึ้นไป ตามโซนยอดนิยมต่างๆ ดังนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul>
												<li>
													ราคาทาวน์โฮม ทาวน์เฮ้าส์โซนกรุงเทพมหานคร กลุ่มคนเริ่มทำงานหันซื้อทาวน์โฮม ทาวน์เฮ้าส์มากขึ้นเหตุต้องการพื้นที่ใช้สอยที่มากขึ้น ตอบโจทย์การอยู่บ้านได้มากกว่า ทำให้แนวโน้มราคาอาจเพิ่มขึ้น โดยราคาทาวน์เฮ้าส์ ทาวน์โฮมที่ไม่เกิน 3 ล้านบาทยังคงเป็นอุปทานหลักในตลาดนี้อยู่ แต่ถ้าอยากได้ทำเลใจกลางเมือง ก็จะมีราคาระดับราคา 5-7 ล้านบาท (ทำเลอ่อนนุช-บางนา) และระดับราคามากกว่า 7 ล้านบาท (ทำเลจตุจักร-ลาดพร้าว)
												</li>
												<li>
													ราคาทาวน์โฮม ทาวน์เฮ้าส์โซนสมุทรปราการ ยังมีราคาต่ำกว่า 2 ล้านให้เห็นอยู่ในหลายๆ โซนของสมุทรปราการ เช่น ทำเลถนนเทพารักษ์ บางพลี สมุทรปราการ มีราคาที่ดินตั้งแต่ 10,000-19,000 บาท/ตารางวา แต่ในอนาคตจะมีการขยับขึ้นอีกแน่นอนจากการมาของอสังหาเมกะโปรเจ็กต์ในแถบบางนา
												</li>
												<li>
													ราคาทาวน์โฮม ทาวน์เฮ้าส์โซนชลบุรี มีหลากหลายเรตราคาตั้งแต่ราคา 1 ล้านไปจนถึง 7 ล้านบาทขึ้นไป ขึ้นอยู่กับทำเล โดยทำเลยอดนิยมที่มีแนวโน้มราคาพุ่งสูงขึ้น ได้แก่ ทำเลพัทยา-เขาพระตำหนัก ทำเลหาดจอมเทียน ทำเลนิคมอุตสาหกรรมอมตะนคร-บายพาส ทำเลนิคมอุตสาหกรรมบ่อวิน ทำเลบางแสน-หนองมน-บางพระ
												</li>
												<li>
													ราคาทาวน์โฮม ทาวน์เฮ้าส์โซนนนทบุรี ส่วนใหญ่จะเป็นทาวน์โฮม ทาวน์เฮ้าส์ ราคา 2-3 ล้านบาท ตอบโจทย์ความต้องการซื้อ (ดีมานด์) ของผู้ซื้อ และโซนที่เป็นตลาดของผู้ซื้ออสังหาฯ ประเภทนี้เลยก็คือ โซนบางบัวทอง-บางใหญ่ ซึ่งราคาเปิดตัวสูงขึ้นเฉลี่ย 3% ต่อปีเลยทีเดียว
												</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกอสังหา ทาวน์โฮม ทาวน์เฮ้าส์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ทำเลที่อยู่อาศัยการเลือกซื้ออสังหา ทาวน์โฮม ทาวน์เฮ้าส์
								</h3>
								<p class="mt-2 mb-0">
									การเลือกซื้อบ้านในหมู่บ้านทาวน์โฮมหรือทาวน์เฮ้าส์ สิ่งสำคัญที่สุดก็คงจะหนีไม่พ้นเรื่องของ ‘ทำเล’ ที่ก็ควรเลือกซื้อในทำเลที่ตอบโจทย์กับคุณมากที่สุดในทุกๆ ด้าน เช่น
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul class="mt-2 mb-0">
												<li>
													เลือกซื้ออสังหาประเภททาวน์โฮม ทาวน์เฮ้าส์ที่เดินทางไปทำงานสะดวก
												</li>
												<li>
													เลือกซื้อบ้านทาวน์โฮม บ้านทาวน์เฮ้าส์ที่อยู่ใกล้กับสถานศึกษา สถานพยาบาล หรือสถานที่สำคัญๆ ที่คุณและคนในครอบครัวมักจะไปกันบ่อยๆ
												</li>
												<li>
													เลือกซื้ออสังหาประเภททาวน์โฮม ทาวน์เฮ้าส์ในทำเลที่เคยอยู่และรู้สึกคุ้นเคยจะช่วยทำให้ปรับตัวได้ง่ายขึ้น
												</li>
												<li>
													เลือกซื้อบ้านทาวน์โฮม บ้านทาวน์เฮ้าส์ในทำเลที่มีรถไฟฟ้าตัดผ่านจะช่วยทำให้ราคาของบ้านไม่มีวันลด มีแต่จะเพิ่มขึ้นเรื่อยๆ ตามราคาของที่ดินที่เพิ่มขึ้น
												</li>
											</ul>
											<p class="mt-2">
												โดยทำเลในโซนกรุงเทพมหานคร ปริมณฑล หรือหัวเมืองในภาคต่างๆ ส่วนใหญ่จะสามารถตอบโจทย์รูปแบบการอยู่อาศัยให้กับคุณได้ เพียงแต่ต้องเลือกพื้นที่ ‘ที่ใช่’ และตรงใจมากที่สุด
											</p>
											<h3 class="mt-2">
												การเดินทางอสังหาประเภท ทาวน์โฮม ทาวน์เฮ้าส์ ในโซนต่างๆ
											</h3>
											<ul class="mt-2 mb-0">
												<li>
													โซนกรุงเทพมหานคร มีการเดินทางที่สะดวกสบาย เพราะเป็นเมืองหลวงที่เป็นแหล่งงาน และแหล่งท่องเที่ยวทั้งการคมนาคมโดยใช้รถใช้ถนน ซึ่งถนนหลักส่วนใหญ่เชื่อมต่อถึงกัน และตามตรอกซอกซอยก็ยังทะลุถึงกันได้ด้วย นอกจากนี้ยังมีรถไฟฟ้าเชื่อมต่อทุกโซนของกรุงเทพฯ เอาไว้ เช่น รถไฟฟ้า BTS รถไฟฟ้า MRT รถไฟฟ้าสายสีแดง รถไฟฟ้าสายสีม่วง รถไฟฟ้าสายสีส้ม รถไฟฟ้าสายสีแดง รถไฟฟ้าสายสีเหลือง ฯลฯ และหลายสถานีกลายเป็น HUB ที่อยู่อาศัยหลักของคนทำงาน เช่น เช่น MRT พระราม 9, BTS สุขุมวิท, MRT ลาดพร้าว, BTS จตุจักร, BTS วงเวียนใหญ่ เป็นต้น ทำให้การเดินทางในกรุงเทพฯ เป็นไปอย่างรวดเร็วมากขึ้น
												</li>
												<li>
													โซนสมุทรปราการ เป็นจังหวัดที่เชื่อมต่อมายังตัวเมืองกรุงเทพฯ ชั้นในได้ง่ายจากการวิ่งตรงเข้าสู่ถนนสุขุมวิท หรือจะวิ่งออกนอกเมืองไปยังฉะเชิงเทรา หรือชลบุรีก็ทำได้ง่ายจากการขึ้นทางด่วน นอกจากนี้ยังมีรถไฟฟ้าตัดผ่านหลายสาย เช่น รถไฟฟ้าสายสีเหลือง ซึ่งเป็นรถไฟฟ้าสายอนาคต และ รถไฟฟ้า BTS ส่วนต่อขยายแบริ่ง-บางปูสายปัจจุบัน ซึ่งมีสถานีทั้งหมด ดังนี้ สถานีบางนา สถานีแบริ่ง สถานีสำโรง สถานีปู่เจ้าสมิงพราย สถานีช้างเอราวัณ สถานีโรงเรียนนายเรือ สถานีปากน้ำ สถานีศรีนครินทร์ สถานีแพรกษา สถานีสายลวด จนปัจจุบันมีถึงสถานีการเคหะฯ ส่วนในอนาคตมีแผนการจะขายไปจนถึงสถานีบางปู
												</li>
												<li>
													โซนชลบุรี เป็นเมืองท่า เมืองหลักทางฝั่งตะวันออกของไทย และเป็นจังหวัดหนึ่งในเขตพัฒนาพิเศษภาคตะวันออก (EEC) ทำให้การเดินทางค่อนข้างสะดวก ทั้งเข้าเมืองและออกเมือง รวมถึงการเดินทางมายังกรุงเทพฯ ยังสามารถใช้ทางด่วนวิ่งตรงมายังกรุงเทพฯ ได้เลย นอกจากนี้ในอนาคตยังมีโครงการทำรถไฟฟ้าความเร็วสูงเชื่อมต่อ 3 สนามบินทั้งสนามบินดอนเมือง สนามบินสุวรรณภูมิ และสนามบินอู่ตะเภาเข้าด้วยกัน
												</li>
												<li>
													โซนนนทบุรี เป็นหนึ่งในจังหวัดปริมณฑลที่อยู่ใกล้กรุงเทพฯ ทำให้การเดินทางสะดวกสบายด้วยถนนหลักสายต่างๆ เช่น ถนนราชพฤกษ์, ถนนรัตนาธิเบศร์ และยังมีรถไฟฟ้าสายสีม่วงตัดผ่านถึง 17 สถานี ได้แก่ สถานีเตาปูน สถานีบางซ่อน สถานีวงศ์สว่าง สถานีแยกติวานนท์ สถานีกระทรวงสาธารณสุข สถานีศูนย์ราชการนนทบุรี สถานีบางกระสอ สถานีแยกนนทบุรี 1 สถานีสะพานพระนั่งเกล้า สถานีแยกนนทบุรี สถานีไทรม้า สถานีบางรักน้อยท่าอิฐ สถานีบางรักใหญ่ สถานีบางพลู สถานีสามแยกบางใหญ่  สถานีตลาดบางใหญ่ และสถานีคลองบางไผ่
												</li>
											</ul>
											<h3 class="mt-2">
												สถานที่ท่องเที่ยวอสังหาประเภท ทาวน์โฮม ทาวน์เฮ้าส์ ในโซนต่างๆ
											</h3>
											<ul class="mt-2 mb-0">
												<li>
													สถานที่ท่องเที่ยวกรุงเทพฯ ใครที่ซื้อทาวน์โฮมใหม่ในโซนกรุงเทพฯ รับรองว่า คุณจะได้ใช้ชีวิตแบบเต็มที่ เพราะนี่คือเมืองหลวงที่รวบรวมแหล่งไลฟ์สไตล์เอาไว้ครบทุกตรอกซอกซอย ทั้งอาหารสตรีทฟู้ด ร้านอาหารชื่อดังหลายสัญชาติ คาเฟ่สำหรับนั่งทำงาน ห้างสรรพสินค้า มีฟิตเนส สวนสาธารณะไว้ให้ออกกำลังกาย ไปจนถึงแหล่งแฮงค์เอาท์อย่างตลาดใหญ่กระจายตัวอยู่ในหลายๆ โซน
												</li>
												<li>
													สถานที่ท่องเที่ยวสมุทรปราการ ส่วนใหญ่จะเป็นเชิงธรรมชาติและเชิงอนุรักษ์ โดดเด่นในเรื่องของความเป็นธรรมชาติใกล้เมือง เช่น บางกระเจ้า สถานีตากอากาศบางปู เมืองโบราณ สมุทรปราการ พิพิธภัณฑ์ช้างเอราวัณ วัดอโศการาม เป็นต้น
												</li>
												<li>
													สถานที่ท่องเที่ยวชลบุรี เป็นจังหวัดท่องเที่ยวยอดฮิตทั้งพัทยา บางละมุง  สัตหีบ ศรีราชา ในตัวเมืองชลบุรี  เรียกได้ว่า มาเที่ยวได้เรื่อยๆ เพราะมีชายหาดสวยงามหลายจุด มีอาหารทะเลอร่อย แถมยังมีสถานที่ท่องเที่ยวอีกหลายแห่งที่พลาดไม่ได้ เช่น สะพานชลมารควิถี แกรนด์แคนยอนคีรี ปราสาทสัจธรรม เขาพระตำหนัก เป็นต้น
												</li>
												<li>
													สถานที่ท่องเที่ยวนนทบุรี เหมาะสำหรับคนที่อยากอยู่ อยากเที่ยวแบบใกล้กรุง แต่ก็ยังได้สัมผัสกับธรรมชาติในสไตล์เมืองเก่า และนี่คือสถานที่ท่องเที่ยวยอดนิยม เช่น ท่าน้ำนนท์ เกาะเกร็ด ตลาดนกฮูก ศาลากลางจังหวัดนนทบุรี (หลังเก่า) วัดบรมราชากาญจนาภิเษกอนุสรณ์ (วัดเล่งเน่ยยี่2) ตลาดน้ำวัดตะเคียน เป็นต้น
												</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<template v-else-if="content === 'condo'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								คอนโด คอนโดมิเนียม (Condo) พร้อมอยู่
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									แนะนำโครงการอสังหาคอนโดมิเนียมต่างๆ ไม่ว่าจะเป็นคอนโดมือสอง คอนโดแต่งครบพร้อมอยู่ คอนโดโครงการอสังหาใหม่ ในหลากหลายเรตราคา ทั้งคอนโดราคาไม่เกิน 1 ล้าน คอนโดราคาล้านต้นๆ อย่างคอนโดราคาไม่เกิน 2 ล้าน หรือถ้าเป็นกลุ่มที่มีกำลังซื้อสูงก็อาจจะมองหาคอนโดราคาไม่เกิน 10 ล้าน หรือคอนโดราคาไม่เกิน 20 ล้านอยู่
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2">
												ถ้าหากคุณต้องการซื้อขายคอนโดที่ใช่ ในทำเลที่ดีที่สุด ทั้งทำเลใจกลางเมือง ทำเลย่านชานเมือง ทำเลต่างจังหวัดตามหัวเมืองต่างๆ ที่มีครบทั้งสิ่งอำนวยความสะดวก ทั้งด้านการเดินทางและการอยู่อาศัย พร้อมทั้งเป็นคอนโดน่าอยู่ด้วยส่วนกลางที่ครบครัน วิวที่หลากหลาย เรามีทีมงานที่ใส่ใจทุกรายละเอียดที่คุณต้องการ ลองฝากซื้อ-ขายคอนโดกับเราได้เลย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ซื้อ คอนโด ดีอย่างไร
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									วิวสวย ทำเลดี
								</h3>
								<p class="mt-2">
									เพราะคอนโดมิเนียมเป็นอาคารสูงอย่างน้อย 8 ชั้น ทำให้สามารถมองเห็นวิวสวยๆ ของเมือง หรือพื้นที่ส่วนกลางจากมุมสูงได้ อีกทั้งคอนโดมิเนียมส่วนใหญ่ยังเป็นคอนโดทำเลดี คอนโดในเมือง เพื่อตอบโจทย์ชีวิตของคนรุ่นใหม่ที่ทำงานอยู่ในย่านใจกลางเมืองนั่นเอง
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-3">
												ประหยัดเวลาและงบในกระเป๋า
											</h3>
											<p class="mt-2">
												Condo ส่วนใหญ่จะอยู่ไม่ไกลจากระบบการคมนาคมต่างๆ เช่น ใกล้รถไฟฟ้า ใกล้ทางด่วน อยู่ในซอยที่สามารถลัดเลาะออกไปได้หลายเส้นทาง และถึงแม้จะเป็นทำเลที่แสนจะสะดวกสบาย ช่วยให้คุณประหยัดเวลาการเดินทางแล้ว คุณยังสามารถหาคอนโดราคาสามไม่เกิน 3 แสนได้ แม้จะเป็นพื้นที่ยอดฮิตก็ตาม
											</p>
											<h3 class="mt-3">
												ปล่อยเช่าง่าย ขายคล่อง
											</h3>
											<p class="mt-2">
												ถ้าเป็นห้องชุดที่ตกแต่งภายในสวย อยู่ทำเลดี เช่น คอนโดแถวสุขุมวิท อีกทั้งยังเป็นคอนโดที่มีชื่อเสียงในย่านนั้นๆ การจะลงทุนทำคอนโดปล่อยเช่า หรือจะประกาศขายคอนโดนั้นก็ไม่ใช่เรื่องยากที่จะหาผู้เช่าและผู้ซื้อ ขอเพียงคุณพร้อมที่จะขาย เราก็พร้อมที่จะดูแลให้แบบครบวงจร
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาคอนโดน่าอยู่
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									หากใครตามหาคอนโดราคาถูก คอนโดมือสอง คอนโดน่าอยู่ คอนโดใจกลางเมือง มาลองดูราคาของคอนโดในแต่ละพื้นที่ยอดฮิตไปพร้อมๆ กันเลยดีกว่า
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul>
												<li>
													ราคาคอนโดโซนกรุงเทพมหานครนั่นมีมากมายหลายราคาขึ้นอยู่กับทำเล โดยตลาดใหม่คอนโดราคาย่อมเยาบนทำเลนอกเมือง (affordable market) ที่มีระดับราคาต่ำกว่า 1 ล้านบาท หรือต่ำกว่า 50,000 บาทต่อตารางเมตรยังมีให้เห็น และผู้คนยังให้ความสนใจในคอนโดเหล่านี้มากเป็นพิเศษ ส่วนตลาดคอนโดระดับ Luxury นั้นสามารถมีราคาเฉลี่ยสูงถึง 290,000 บาท/ตารางเมตรเลยทีเดียว
												</li>
												<li>
													ราคาคอนโดโซนสมุทรปราการนั้นมีแนวโน้มสูงขึ้นเรื่อยๆ โดยเฉพาะทำเลสุขุมวิทตอนปลาย-บางนาจะมีราคาคอนโดขาย-เช่าอยู่ที่ประมาณ 3 ล้านบาท แต่ถ้าวิ่งไปตามแนวรถไฟฟ้าสายสีเขียวส่วนต่อขยายแบริ่งสมุทรปราการราคาจะสามารถจับต้องได้มากขึ้น ในระดับต่ำล้าน หรือล้านต้นๆ ก็มี
												</li>
												<li>
													ราคาคอนโดโซนชลบุรี จะมีเริ่มตั้งแต่ 2 ล้านต้นๆ ส่วน “พื้นที่ใกล้เคียงอย่างนิคมอุตสาหกรรมอมตะนคร” โครงการส่วนใหญ่เป็นแนว Low Rise  มีราคาขายคอนโด 1 ล้านต้นๆ ส่วนทำเลศักยภาพที่มีเรตราคาคอนโดมากที่สุดจะเป็นศรีราชาโดยขายเริ่มต้นอยู่ที่ 1.8 ล้านบาทถึงหลัก 10 ล้านบาทเลยทีเดียว
												</li>
												<li>
													ราคาคอนโดโซนนนทบุรี โดยรวมแล้วคอนโดย่านนนทบุรีจะอยู่ที่ราคาประมาณ 1,500,000 บาท – 30,000,000 บาท โดยราคาที่แพงที่สุดจะขึ้นอยู่กับความสะดวกสบายและติดกับสถานที่ต่างๆ และส่วนใหญ่จะตั้งอยู่บริเวณถนนแจ้งวัฒนะ และบริเวณอ.เมืองนนทบุรี
												</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกคอนโดในการอยู่อาศัย
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ทำเลที่อยู่อาศัยในการเลือกซื้อคอนโด
								</h3>
								<p class="mt-2 mb-0">
									การเลือกซื้อคอนโด ไม่ว่าจะเพื่ออยู่อาศัยเอง หรือเพื่อลงทุน สิ่งแรกที่ควรคำนึงถึงก็คือ ทำเล ซึ่งการเลือกทำเลที่ตั้งของคอนโดมิเนียม ก็มีจุดสังเกตสำคัญๆ ที่ควรดู ดังนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul class="mt-2 mb-0">
												<li>
													เลือกคอนโดใกล้รถไฟฟ้า BTS MRT สายต่างๆ หากคุณไม่มีรถยนต์ส่วนตัว โดยคอนโดติดรถไฟฟ้าส่วนใหญ่จะอยู่ในระยะไม่เกิน 800 เมตร เพราะเป็นระยะที่เดินถึงได้
												</li>
												<li>
													เลือกคอนโดมิเนียมที่อยู่ใกล้ธนาคาร เพราะบริเวณนั้นจะมีกิจกรรมทางเศรษฐกิจเห็นได้ชัดกว่าทำเลอื่นๆ
												</li>
												<li>
													เลือก Condo ที่มีสิ่งอำนวยความสะดวกรายล้อม เช่น โรงเรียน โรงพยาบาล ตลาดนัด ห้างสรรพสินค้า ร้านสะดวกซื้อ เพื่อให้การใช้ชีวิต และการซื้อของทำได้ง่ายมากยิ่งขึ้น
												</li>
												<li>
													เลือกคอนโดมิเนียมที่ขับรถได้สะดวก เช่น มีซอยลัดเลาะออกได้หลายเส้นทาง
												</li>
												<li>
													เลือกคอนโดมิเนียมที่มีสภาพแวดล้อมที่ดีและมีความปลอดภัยสูง ไม่เปลี่ยว ไม่น่ากลัว
												</li>
												<li>
													เลือกคอนโดที่มีแนวโน้ม Capital Gain ที่เพิ่มขึ้น
												</li>
											</ul>
											<p class="mt-2">
												โดยทำเลในโซนกรุงเทพมหานคร ปริมณฑล หรือหัวเมืองในภาคต่างๆ ส่วนใหญ่จะสามารถตอบโจทย์รูปแบบการอยู่อาศัยให้กับคุณได้ เพียงแต่ต้องเลือกพื้นที่ ‘ที่ใช่’ และตรงใจมากที่สุด
											</p>
											<h3 class="mt-2">
												การเดินทางแถวคอนโดในโซนต่างๆ
											</h3>
											<ul class="mt-2 mb-0">
												<li>
													การเดินทางในโซนกรุงเทพมหานคร ด้วยความเป็นเมืองหลวงที่มีรถไฟฟ้าตัดผ่านหลากหลายสาย ทำให้มีสถานีสำคัญๆ ที่เป็นแหล่งรวมที่อยู่อาศัยและแหล่งงานไปในตัว เช่น สถานีอโศก สถานีพร้อมพงษ์ สถานีทองหล่อสถานีพระราม 9 สถานีลาดพร้าว สถานีจตุจักร เป็นต้น ซึ่งทั้งหมดนี้เป็นย่าน CBD และ NEW CBD ที่ได้รับความนิยมเป็นอย่างมาก นอกจากนี้การเดินทางโดยการใช้รถยนต์ก็สะดวก เพราะกรุงเทพฯ มีทางด่วนให้ใช้งานหลายจุด และถนนเส้นหลักก็เชื่อมต่อถึงกันได้ในทุกโซนของกรุงเทพมหานคร
												</li>
												<li>
													การเดินทางในโซนสมุทรปราการ เป็นย่านที่เดินทางสะดวก เพราะมีถนนเส้นสำคัญเชื่อมต่อกับถนนสุขุมวิทเพื่อเข้าสู่ใจกลางกรุงเทพได้ เช่น ถนนเทพารักษ์ ถนนบางนา-ตราด ฯลฯ นอกจากนี้ยังมีรถไฟฟ้าสายสีเหลือง (อนาคต) ตัดผ่าน และก็มีรถไฟฟ้าสายสีเขียวส่วนต่อขยายแบริ่ง-สมุทรปราการเปิดให้บริการอยู่หลายสถานีด้วยกัน ได้แก่ สถานีบางนา สถานีแบริ่ง สถานีสำโรง สถานีปู่เจ้าสมิงพราย สถานีช้างเอราวัณ สถานีโรงเรียนนายเรือ สถานีปากน้ำ สถานีศรีนครินทร์ สถานีแพรกษา สถานีสายลวด จนปัจจุบันมีถึงสถานีการเคหะฯ (ในอนาคตมีแผนการจะขายไปจนถึงสถานีบางปู) ทำให้ย่านนี้เจริญเติบโตอย่างรวดเร็ว
												</li>
												<li>
													การเดินทางในโซนชลบุรี เป็นจังหวัดที่เดินทางได้สะดวก และเป็นเมืองท่าสำคัญที่นักลงทุนชาวไทยและชาวต่างชาตินิยมเดินทางมาเป็นประจำ ทำให้การใช้รถใช้ถนนในการเดินทางระหว่างอำเภอ เช่น ชะอำ ศรีราชา บางแสน ค่อนข้างสะดวก อีกทั้งยังมีทางด่วนเชื่อมต่อยาวมาจนถึงกรุงเทพฯ ทางโซนบางนา ใช้เวลาไม่ถึง 2 ชั่วโมงเท่านั้นเอง
												</li>
												<li>
													การเดินทางในโซนนนทบุรี เป็นจังหวัดปริมณฑลที่อยู่ใกล้กรุงเทพฯ มีถนนเส้นหลักให้ใช้หลากหลายเส้นทาง และที่สำคัญมีรถไฟฟ้าสายสีม่วงตัดผ่านถึง 17 สถานี ได้แก่ สถานีเตาปูน สถานีบางซ่อน สถานีวงศ์สว่าง สถานีแยกติวานนท์ สถานีกระทรวงสาธารณสุข สถานีศูนย์ราชการนนทบุรี สถานีบางกระสอ สถานีแยกนนทบุรี 1 สถานีสะพานพระนั่งเกล้า สถานีแยกนนทบุรี สถานีไทรม้า สถานีบางรักน้อยท่าอิฐ สถานีบางรักใหญ่ สถานีบางพลู สถานีสามแยกบางใหญ่  สถานีตลาดบางใหญ่ และสถานีคลองบางไผ่ ทำให้เป็นจังหวัดที่เติบโตขึ้นอย่างรวดเร็ว ทั้งการมีคอนโดแนวรถไฟฟ้าเพิ่มมากขึ้น มีแหล่งไลฟ์สไตล์ และการลงทุนหลากหลายแบบ
												</li>
											</ul>
											<h3 class="mt-2">
												สถานที่ท่องเที่ยวใกล้เคียงคอนโดในโซนต่างๆ
											</h3>
											<ul class="mt-2 mb-0">
												<li>
													แหล่งท่องเที่ยวใกล้คอนโดกรุงเทพ ส่วนใหญ่คอนโดกทม. จะอยู่ใจกลางเมือง และใกล้ถนนจึงเดินทางไปจับจ่ายซื้อของได้ง่าย และถ้าเลือกคอนโดติดรถไฟฟ้าก็จะมีทั้งห้างสรรพสินค้า คาเฟ่ ร้านสะดวกซื้อ แหล่งแฮงค์เอาท์ สวนสาธารณะ ร้านอาหารชื่อดังทั้งไทยและเทศให้ไปเดิน ชอป ชิม ชิลล์ได้ตลอดทั้งวัน
												</li>
												<li>
													แหล่งท่องเที่ยวใกล้คอนโดสมุทรปราการ เป็นเมืองที่มีทั้งความเจริญ ผสมกับแหล่งท่องเที่ยวเชิงอนุรักษ์ คุณยังสามารถพบเห็นคาเฟ่ ร้านอาหาร ร้านค้า ตามถนนสายหลักของจังหวัดสมุทรปราการ ส่วนถ้าต้องการความสงบก็หลบไปเที่ยวแถวบางกระเจ้า สถานีตากอากาศบางปู ป่าชายเลน เมืองโบราณ หรือไปสนุกกับสัตว์นานาชนิดที่ฟาร์มจระเข้และสวนสัตว์สมุทรปราการได้เลย
												</li>
												<li>
													แหล่งท่องเที่ยวใกล้คอนโดชลบุรี ถ้าซื้อคอนโดมิเนียมเป็นที่พักตากอากาศที่ชลบุรี ก็จะเข้าถึงการพักผ่อนริมทะเลอย่างแท้จริง เพราะอำเภอต่างๆ ในชลบุรีขึ้นชื่อเรื่องสถานที่ท่องเที่ยวริมหาดดัง เช่น หาดชะอำ หาดบางแสน ไปจนถึงการเที่ยวเกาะอย่างเกาะสีชัง หรือเกาะล้านก็มีเช่นเดียวกัน
												</li>
												<li>
													แหล่งท่องเที่ยวใกล้คอนโดนนทบุรี ส่วนใหญ่จะเป็นการท่องเที่ยวแบบเชิงธรรมชาติ วัฒนธรรม เช่น เกาะเกร็ด วัดเล่งเน่ยยี่ 2 สวนมาลัยบัววิคตอเรีย หรือถ้าเป็นสวยคาเฟ่ย่านนนทบุรีก็มีร้านอาหารและคาเฟ่มากมายติดสถานีรถไฟฟ้าให้เลือกเข้าไปนั่งเล่น นั่งทำงานได้ตลอดทั้งเส้นทาง
												</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<template v-else-if="content === 'shophouse'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/home-bk.png"
									height="25"
									class="mr-2"
								>
								ซื้อ-ขาย อาคารพาณิชย์ ตึกแถว ห้องแถว
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									แนะนำอาคารพาณิชย์มือสอง ตึกแถวมือสอง อาคารพาณิชย์ อสังหาใหม่ อาคารพาณิชย์กรุงเทพ อาคารพาณิชย์ชั้นเดียว อาคารพาณิชย์ 1 ชั้น อาคารพาณิชย์ 2 ชั้น อาคารพาณิชย์ 3 ชั้น ห้องแถวขายของชั้นเดียว ในหลากหลายราคาทั้งแบบไม่เกิน 1 ล้าน ไม่เกิน 2 ล้าน ไม่เกิน 3 ล้าน ไม่เกิน 4 ล้าน หรือไม่เกิน 5 ล้าน หรือถ้าต้องการเซ้งตึกแถว 2 คูหา 3 คูหาในทำเลทอง เหมาะสมกับการทำกิจการ ค้าขาย ต้องการอาคารพาณิชย์ขายทอดตลาดที่นี่มีให้เลือกครบ เพียงแค่ค้นหาทำเลที่สะดวก ใกล้รถไฟฟ้า ใกล้ทางด่วน อยู่ในแหล่งชุมชน ที่ The Best พร้อมให้บริการแบบครบวงจร หาให้ตึกแถวที่คุณต้องการได้อย่างแน่นอน
								</p>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/3star-bk.png"
									height="25"
									class="mr-2"
								>
								ซื้อ อาคารพาณิชย์ ตึกแถว ห้องแถว ดีอย่างไร
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									ซื้อ ขาย เช่า เซ้ง อาคารพาณิชย์ หรือที่หลายคนเรียกกว่า ตึกแถวหรือห้องแถว ทั้งในกรุงเทพมหานคร ปริมณฑล และทั่วประเทศ โดยอาคารเหล่านี้จะเป็นอาคารสำหรับการค้า อาจจะเปิดเป็นร้านอาหาร คาเฟ่ อาคารสำนักงาน ไปจนถึงใช้อยู่อาศัยได้ด้วย หากเลือกขายหรือซื้ออาคารพาณิชย์ได้ถูกที่ ถูกทำเล ย่อมเพิ่มโอกาสในการลงทุนจากการค้าขายที่ดีขึ้น และการปล่อยเช่าอาคารพาณิชย์หรือขายในอนาคต
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<h3 class="mt-2">
												ทำเลน่าลงทุน
											</h3>
											<p class="mt-2">
												บ้านอาคารพาณิชย์ส่วนใหญ่มักอยู่ทำเลในเมือง เป็นทำเลที่มีคนพลุกพล่านส่งเสริมให้มีโอกาสทำกิจการต่างๆ ได้ง่ายขึ้น โดยตึกแถวทำเลค้าขายมักจะเป็นตึกแถวริมถนน ใครที่ต้องการขาย ให้เช่า เซ้ง อาคารพาณิชย์ ตึกแถว ห้องแถวมีโอกาสทำกำไรได้ดีจากการเลือกทำเลที่น่าลงทุน
											</p>
											<h3 class="mt-3">
												สิ่งอำนวยความสะดวกครบครัน
											</h3>
											<p class="mt-2">
												ตึกแถวกรุงเทพ ตึกแถวโซนปริมณฑลหรือบริเวณหัวเมืองใหญ่ มักรายล้อมด้วยสิ่งอำนวยความสะดวกครบครัน เพื่อรองรับความคึกคักของผู้คนในทำเล ไม่ว่าจะเป็นห้างร้าน สถานที่ราชาการ บริษัทเอกชน ธนาคาร ทำให้เป็นการลงทุนซื้อโอกาสทางการค้าขายไปพร้อมๆ กับการซื้อสิ่งอำนวยความสะดวกใกล้ๆ ไปด้วย
											</p>
											<h3 class="mt-3">
												เพิ่มโอกาสทำกิจการ
											</h3>
											<p class="mt-2">
												การซื้อตึกแถว ตึกอาคาร เป็นการลงทุนอสังหาริมทรัพย์รูปแบบหนึ่ง ที่นำไปใช้เพื่อเพิ่มโอกาสในการทำกิจการส่วนตัว หรือจะซื้อเก็บไว้ใช้สำหรับเก็งกำไรก็ได้ เนื่องจากทำเลที่ตั้งของตึกอาคารพาณิชย์ส่วนใหญ่มักอยู่ในทำเลที่ดี ใกล้แหล่งชุมชน ทำให้เป็นที่ต้องการและราคาขึ้นอย่างต่อเนื่องในทุกๆ ปี
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาอาคารพาณิชย์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<ul class="mt-2">
									<li>
										แนวโน้มราคาอาคารพาณิชย์ในกรุงเทพมหานคร ปกติแล้วราคาอาคารพาณิชย์ในกรุงเทพฯ จะมีการปรับตัวสูงขึ้นทุกปี โดยเฉพาะราคาค่าเช่าที่จะมีการปรับขึ้น 4-5% ต่อปี และจะมีอุปสงค์การเช่าพื้นที่เพิ่มขึ้นเฉลี่ย 160,000 ตารางเมตรต่อปี และมีแนวโน้มเพิ่มขึ้นจากการขยายตัวของเมืองตามแนวรถไฟฟ้าส่วนต่อขยาย เช่น รถไฟฟ้าสายสีเหลือง รถไฟฟ้าสายสีส้ม เป็นต้น
									</li>
									<li>
										แนวโน้มราคาอาคารพาณิชย์ในสมุทรปราการ เนื่องจากเป็นพื้นที่ปริมณฑลอาจทำให้ราคาอาคารพาณิชย์ในบางพื้นที่มีราคาที่ไม่สูงมากนัก และสามารถซื้อหรือเช่าเพื่อทำกิจการได้ โดยแนวโน้มของราคาที่คนต้องการซื้อจะอยู่ที่ประมาณ 2-5 ล้านบาท
									</li>
									<li>
										แนวโน้มราคาอาคารพาณิชย์ในชลบุรี จะมีจำนวนร้อยละ 7 ของพื้นที่เป็นอาคารพาณิชย์พักอาศัย ซึ่งเป็นสัดส่วนที่น้อยที่สุดในจำนวนของรูปแบบที่พักอาศัยทั้งหมด ทำให้มีแนวโน้มของราคาเพิ่มขึ้นเรื่อยๆ ซึ่งในปัจจุบันราคาตึกแถวระดับ 1 ล้านบาทยังพอมีให้เห็นอยู่บ้าง แต่อาจจะมีจำนวนน้อยแล้ว เพราะราคาที่ดินของชลบุรีนั้นพุ่งสูงขึ้นเรื่อยๆ ในทุกๆ ปี
									</li>
									<li>
										แนวโน้มราคาอาคารพาณิชย์ในนนทบุรี สำหรับจังหวัดนี้มีพื้นที่ด้านพาณิชยกรรม ซึ่งเป็นย่านชุมชนประมาณ 15% ของพื้นที่ทั้งหมด โดยจะกระจายตัวอยู่บนถนนเส้นหลักต่างๆ โดยเฉพาะท่าน้ำนนท์ ติวานนท์ สะพานพระราม 5 งามวงศ์วาน ซึ่งเป็นย่านการค้าหลัก ราคาของตึกแถวในย่านนี้จึงเป็นราคาที่จับต้องได้ โดยส่วนใหญ่จะเริ่มต้นที่ 1.5 ล้านบาทเป็นต้นไป
									</li>
								</ul>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกอาคารพาณิชย์
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ทำเลที่อยู่อาศัยการเลือกซื้ออาคารพาณิชย์
								</h3>
								<p class="mt-2 mb-0">
									“อาคารพาณิชย์” ที่ดี ทำกิจการให้เจริญรุ่งเรือง แน่นอนว่าต้องสัมพันธ์กับการเลือกทำเล มาดูกันดีกว่าควรเลือกซื้อขายอาคารพาณิชย์อย่างไรบ้าง ถึงจะทำให้กิจการเติบโต
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<ul class="mt-2">
												<li>
													เลือกซื้อขายตึกแถวในย่านธุรกิจใหญ่ที่สำคัญๆ เช่น CBD อย่างอโศก พร้อมพงษ์ ทองหล่อ, NEW CBD อย่างพระราม 9 ห้วยขวาง ลาดพร้าว หรือเลือกตามจังหวัดปริมณฑล จังหวัดหัวเมืองก็จะได้ราคาที่สามารถจับต้องได้ โดยยังเป็นทำเลชุมชนที่มีคนอาศัยอยู่มากด้วย
												</li>
												<li>
													เลือกซื้ออาคารพาณิชย์สวยๆ ติดถนนเส้นหลัก หรืออยู่ไม่ไกลจากถนนมากนัก
												</li>
												<li>
													เลือกซื้ออาคารพาณิชย์ติดตลาด ติดโรงเรียน โรงพยาบาล อาคารสำนักงาน หรือแหล่งที่มีคนพลุกพล่าน
												</li>
												<li>
													เลือกซื้ออาคารพาณิชย์ 2 คูหา อาคารพาณิชย์ค้าขายได้ เพื่อที่ในอนาคตต้องการขยายกิจการจะได้สามารถทุบตึกแถวให้เชื่อมเข้าหากันได้ง่ายขึ้น
												</li>
											</ul>
											<h3 class="mt-2">
												การเดินทางอาคารพาณิชย์ในโซนต่างๆ
											</h3>
											<ul class="mt-2 mb-0">
												<li>
													การเดินทางโซนกรุงเทพมหานคร เป็นย่านธุรกิจที่คนพลุกพล่าน การทำธุรกิจส่วนใหญ่ต้องการความรวดเร็ว ดังนั้น จึงเป็นทำเลทองที่เดินทางสะดวก โดยมีให้เลือกใช้บริการทั้ง รถประจำทาง วินมอเตอร์ไซค์ หรือรถไฟฟ้าหลากหลายสี ซึ่งมีสถานีสำคัญๆ ที่น่าสนใจจับจองเป็นเจ้าของอาคารพาณิชย์ เพราะเป็นแหล่งทำงานที่มีศักยภาพ เช่น สถานีอโศก สถานีพร้องพงษ์ สถานีทองหล่อ สถานีพระราม 9 สถานีลาดพร้าว สถานีจตุจักร สถานีวงเวียนใหญ่ เป็นต้น ส่วนการเดินทางด้วยรถยนต์ก็ค่อนข้างง่าย ถนนเชื่อมต่อกันทุกเส้น ในเวลาชั่วโมงเร่งด่วนสามารถใช้ทางด่วนได้ หรือจะใช้ตรอกซอกซอยในการลัดเลาะก็ได้เช่นเดียวกัน
												</li>
												<li>
													การเดินทางโซนสมุทรปราการ สมุทรปราการเป็นย่านอาคารพาณิชย์ที่ดีอีกแห่ง เนื่องจากเป็นย่านใกล้กรุงเทพฯ จึงรองรับการขยายตัวของเมือง ใกล้สนามบิน ใกล้โรงงาน และใกล้แหล่งชุมชน ทำให้การเดินทางในย่านนี้สะดวกสบาย มีทั้งทางด่วน ถนนหลักสายเส้นทาง เชื่อมต่อกับถนนสุขุมวิทเพื่อเข้าตัวเมือง หรือวิ่งออกนอกเมืองไปยังฉะเชิงเทรา หรือชลบุรีได้ นอกจากนี้ ยังมีรถไฟฟ้าสายสีเขียวตัดผ่าน โดยมีสถานีสำคัญ ได้แก่ สถานีบางนา สถานีแบริ่ง สถานีสำโรง สถานีปู่เจ้าสมิงพราย สถานีช้างเอราวัณ สถานีโรงเรียนนายเรือ สถานีปากน้ำ สถานีศรีนครินทร์ สถานีแพรกษา สถานีสายลวด จนปัจจุบันมีถึงสถานีการเคหะฯ (ในอนาคตมีแผนการจะขายไปจนถึงสถานีบางปู)
												</li>
												<li>
													การเดินทางโซนชลบุรี เป็นย่านการค้าทางเรือและเป็นแหล่งท่องเที่ยว อาคารพาณิชย์ในย่านนี้จึงเป็นกิจการต่างๆ ที่รองรับนักท่องเที่ยวเป็นส่วนใหญ่ และด้วยความเป็นเมืองใหญ่ที่มีครบทั้งที่เที่ยวและแหล่งทำงาน การเดินทางเข้า-ออกเมืองจึงสะดวก ทั้งการวิ่งเข้ากรุงเทพฯ ก็มีเส้นทางด่วนให้ใช้ หรือในอนาคตต้องการเดินทางไวขึ้น ก็มีแผนจะสร้างรถไฟฟ้าความเร็วสูงเชื่อมสนามบินดอนเมือง สนามบินสุวรรณภูมิ และสนามบินอู่ตะเภาเข้าไว้ด้วยกันอีกด้วย
												</li>
												<li>
													การเดินทางโซนนนทบุรี เป็นจังหวัดใกล้กรุงเทพฯ จึงได้รับอิทธิพลความเจริญไปค่อนข้างมาก อาคารพาณิชย์ส่วนใหญ่อยู่ในทำเลดี ติดถนน ในจุดที่มีคนพลุกพล่าน โดยถนนเส้นหลักที่ใช้เดินทางก็มีมากมายหลายสาย เช่น  ถนนราชพฤกษ์, ถนนรัตนาธิเบศร์, ถนนงามวงศ์วาน, ถนนพิบูลสงคราม เป็นต้น และยังมีรถไฟฟ้าสายสีม่วงตัดผ่าน ได้แก่ สถานีเตาปูน สถานีบางซ่อน สถานีวงศ์สว่าง สถานีแยกติวานนท์ สถานีกระทรวงสาธารณสุข สถานีศูนย์ราชการนนทบุรี สถานีบางกระสอ สถานีแยกนนทบุรี 1 สถานีสะพานพระนั่งเกล้า สถานีแยกนนทบุรี สถานีไทรม้า สถานีบางรักน้อยท่าอิฐ สถานีบางรักใหญ่ สถานีบางพลู สถานีสามแยกบางใหญ่  สถานีตลาดบางใหญ่ และสถานีคลองบางไผ่
												</li>
											</ul>
											<h3 class="mt-2">
												สถานที่สำคัญอาคารพาณิชย์ในโซนต่างๆ
											</h3>
											<ul class="mt-2 mb-0">
												<li>
													สถานที่สำคัญโซนกรุงเทพมหานคร ส่วนใหญ่จะเป็นอาคารสำนักงาน เนื่องจากกรุงเทพฯ เป็นแหล่งงานขขนาดใหญ่ ทำให้มีอาคารพาณิชย์ อาคารสำนักงาน ตึกเช่ามากมาย โดยเฉพาะย่าน New CBD เช่น พระราม 9 ห้วยขวาง ลาดพร้าว และย่าน CBD เช่น อโศก พร้อมพงษ์ ทองหล่อ ที่เป็น HUB งานขนาดใหญ่ อาคารพาณิชย์ในย่านนี้จึงเป็นที่ต้องการของเจ้าของกิจการเป็นอย่างมาก
												</li>
												<li>
													สถานที่สำคัญโซนสมุทรปราการ ส่วนใหญ่จะเป็นพื้นที่อยู่อาศัย และพื้นที่โรงงานขนาดใหญ่ กิจการของอาคารพาณิชย์โดยรอบจึงเป็นอาคารสำนักงาน ร้านค้า ไปจนถึงขายสินค้าเพื่อสนับสนุนการประกอบกิจการของโรงงานในย่านนี้
												</li>
												<li>
													สถานที่สำคัญโซนชลบุรี เป็นย่านธุรกิจแถบชายฝั่งและแหล่งท่องเที่ยว อาคารพาณิชย์ส่วนใหญ่จึงถูกซื้อเพื่อประกอบธุรกิจด้านการขนส่ง โลจิสติกส์ ค้าขาย หรือแม้กระทั่งส่งเสริมการท่องเที่ยวจากการเป็นเมืองที่มีทะเลที่ใกล้กับกรุงเทพฯ มากที่สุด นอกจากนี้ชลบุรียังเป็นเมืองที่มีชาวญี่ปุ่นมา Expat อยู่ค่อนข้างมาก ร้านค้าต่างๆ ส่วนใหญ่จึงมีกลุ่มเป้าหมายเป็นชาวญี่ปุ่นโดยเฉพาะอีกด้วย
												</li>
												<li>
													สถานที่สำคัญโซนนนทบุรี เนื่องจากนนทบุรีเป็นเมืองที่ได้รับอิทธิพลต่อเนื่องจากฝั่งธนบุรี ซึ่งเป็นเมืองเก่ามา ทำให้ย่านนี้มีแหล่งงานด้านข้าราชการค่อนข้างมาก อีกทั้งยังมีแหล่งไลฟ์สไตล์ใหญ่ๆ ไปเปิดตัวอยู่ในแถบบางใหญ่ ทำให้ย่านนี้เป็นย่านของการอยู่อาศัย ท่องเที่ยว และทำงานของคนในพื้นที่เป็นหลัก
												</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-main>
</template>

<script>
const doc = 'projects'

import { mapActions, mapGetters, mapMutations } from 'vuex'

import searchForm from '~/components/2.0/search-form-home'
import propertyCarousel from '~/components/2.0/property-carousel'

export default {
	// scrollToTop: true,
	name: 'CategoryHub',
	layout: 'default_2',

	components: {
		searchForm,
		propertyCarousel,
	},

	async asyncData(context) {
		let data = {
			doc,
			fullPath: context.route.fullPath,
			title: 'Title',
			description: 'Description'
		}

		let path = context.route.path.split('/')
		if (path[path.length - 1] === '') {
			path.splice(path.length - 1, 1)
		}
		let content = path[1]

		// Category
		if (content === 'singlehome') {
			data['title'] = `รวมอสังหา บ้านเดี่ยว หมู่บ้านจัดสรร ${context.store.getters.thaiYear} ซื้อ-ขาย มือสอง พร้อมอยู่ หลายทำเล`
			data['description'] = `รวมอสังหา บ้านเดี่ยว หมู่บ้านจัดสรร ปี ${context.store.getters.thaiYear} ซื้อ-ขาย มือสอง หาบ้าน พร้อมอยู่ หลายทำเล หลากราคา ทั้งกรุงเทพเเละปริมณฑล`
		}
		else if (content === 'townhome') {
			data['title'] = 'รวมอสังหาบ้าน ทาวน์โฮม ทาวน์เฮ้าส์ Townhome-Townhouse ซื้อ ขาย'
			data['description'] = `รวมอสังหาหมู่บ้าน ทาวน์โฮม ทาวน์เฮ้าส์ Townhome-Townhouse ปี ${context.store.getters.thaiYear} ซื้อ ขาย มือสอง พร้อมอยู่ หลายทำเล หลากราคา ทั้งกรุงเทพเเละปริมณฑล`
		}
		else if (content === 'condo') {
			data['title'] = 'รวมคอนโด คอนโดมิเนียม (Condo) ซื้อ ขาย คอนโดมือสอง พร้อมอยู่'
			data['description'] = 'รวมคอนโด คอนโดมิเนียม (Condo) ซื้อ ขาย คอนโดมือสอง น่าอยู่ ทำเลดี พร้อมอยู่ พร้อมราคา ใกล้รถไฟฟ้า BTS MRT ทั้งกรุงเทพเเละปริมณฑล'
		}
		else if (content === 'shophouse') {
			data['title'] = 'รวมประกาศซื้อ ขาย ให้เช่า เซ้ง อาคารพาณิชย์ ตึกแถว ในกรุงเทพเเละต่างจังหวัด'
			data['description'] = 'รวมประกาศซื้อ ขาย ให้เช่า เซ้ง อาคารพาณิชย์ ตึกแถว ห้องแถว ริมถนน ทำเลค้าขาย ในกรุงเทพเเละต่างจังหวัด พร้อมรายละเอียด ราคา'
		}

		await context.store.dispatch('page/initial', data)

		return { path, content }
	},

	data:() => ({
		keepAliveActivated: false,
		loading: false,
	}),

	computed: {
		...mapGetters({
			isMobile: 'isMobile',
			getProperties: 'property/getPropertyId_list',
			getProperty: 'property/getProperty',
			head: 'page/head',
			thaiYear: 'thaiYear',
		}),

		market_selected () {
			if (this.content === 'townhome') {
				return 'TOWNHOUSE'
			} else if (this.content === 'condo') {
				return 'CONDO'
			} else if (this.content === 'shophouse') {
				return 'COMMERCIAL_BUILDING'
			}

			return 'HOME'
		},

		bannerImg () {
			if (this.$route.path === '/singlehome') {
				return '/images/2.0/singlehome-banner.jpg'
			} else if (this.$route.path === '/townhome') {
				return '/images/2.0/townhome-banner.jpg'
			} else if (this.$route.path === '/condo') {
				return '/images/2.0/condo-banner.jpg'
			} else if (this.$route.path === '/shophouse') {
				return '/images/2.0/shophouse-banner.jpg'
			}

			return '/images/2.0/all-project-banner.jpg'
		},
	},

	watch: {

	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
		} else if (this.keepAliveActivated) {
			// this.search()
		}
	},

	created() {

	},

	mounted() {

	},

	methods: {
		...mapActions({
			getPropertyList: 'property/getPropertyList',
			searchProperty: 'property/searchProperty'
		}),
		...mapMutations({
			searchToggle: 'page/searchToggle'
		}),

		area (location, category) {
			if (location === 'samut-prakan') {
				return [
					{ text: 'ศรีนครินทร์', path: `/${location}/${category}/srinakarin` },
					{ text: 'เทพารักษ์', path: `/${location}/${category}/thepharak` },
					{ text: 'บางพลี', path: `/${location}/${category}/bang-phli` },
					{ text: 'บางนา-ตราด', path: `/${location}/${category}/bangna-trad` },
					{ text: 'แพรกษา', path: `/${location}/${category}/phraeksa` },
					{ text: 'บางปู', path: `/${location}/${category}/bangpu` },
					{ text: 'พระประแดง', path: `/${location}/${category}/phra-pradaeng` },
					{ text: 'พระสมุทรเจดีย์', path: `/${location}/${category}/phra-samut-chedi` },
					{ text: 'แบริ่ง', path: `/${location}/${category}/bearing` },
					{ text: 'ลาซาล', path: `/${location}/${category}/lasalle` },
					{ text: 'สำโรง', path: `/${location}/${category}/samrong` },
					{ text: 'บางบ่อ', path: `/${location}/${category}/bang-bo` },
					{ text: 'ปู่เจ้าสมิงพราย', path: `/${location}/${category}/poo-chao-saming-prai` },
					{ text: 'บางเสาธง', path: `/${location}/${category}/bang-sao-thong` },
					{ text: 'ประชาอุทิศ', path: `/${location}/${category}/pracha-uthit` },
				]
			} else if (location === 'bangkok') {
				return [
					{ text: 'ราชพฤกษ์', path: `/bangkok/${category}/ratchaphruek` },
					{ text: 'พระราม2', path: `/bangkok/${category}/rama-2` },
					{ text: 'ลาดพร้าว', path: `/bangkok/${category}/ladprao` },
					{ text: 'พหลโยธิน', path: `/bangkok/${category}/phaholyothin` },
					{ text: 'รามอินทรา', path: `/bangkok/${category}/ramintra` },
					{ text: 'ลาดกระบัง', path: `/bangkok/${category}/lat-krabang` },
					{ text: 'สายไหม', path: `/bangkok/${category}/saimai` },
					{ text: 'อ่อนนุช', path: `/bangkok/${category}/onnut` },
					{ text: 'รามคำแหง', path: `/bangkok/${category}/ramkhamhaeng` },
					{ text: 'พระราม 9', path: `/bangkok/${category}/phra-ram-nine` },
					{ text: 'มีนบุรี', path: `/bangkok/${category}/min-buri` },
					{ text: 'สวนหลวง', path: `/bangkok/${category}/suanluang` },
					{ text: 'พระโขนง', path: `/bangkok/${category}/prakanong` },
					{ text: 'พระราม 3', path: `/bangkok/${category}/ra-ma-three` },
					{ text: 'ปิ่นเกล้า', path: `/bangkok/${category}/pinklao` },
					{ text: 'รัชดา', path: `/bangkok/${category}/ratchadapisek` },
					{ text: 'ดอนเมือง', path: `/bangkok/${category}/don-mueang` },
					{ text: 'ประเวศ', path: `/bangkok/${category}/prawet` },
				]
			} else if (location === 'nontaburi') {
				return [
					// { text: 'บางบัวทอง', path: `/${location}/${category}/bangbuatong` },
					// { text: 'บางใหญ่', path: `/${location}/${category}/bangyai` },
				]
			} else if (location === 'chonburi') {
				return [
					// { text: 'ศรีราชา', path: `/${location}/${category}/sriracha` },
					// { text: 'บางละมุง', path: `/${location}/${category}/banglamung` },
					// { text: 'สัตหีบ', path: `/${location}/${category}/sattaheeb` },
				]
			}
		},
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
h1.red--text {
	font-size: 1.6em;
}
.head-banner {
	position: relative;

	.search-filter {
		position: absolute;
		top: 100px;
		z-index: 2;

		div {
			border-left: solid 4px #c20000;
		}
	}
}
.float-tab {
	margin-top: -52px;

	&::v-deep .v-item-group.v-btn-toggle {
		background: transparent;

		button {
			opacity: unset;
		}
	}
}
.home-cate {
	// background-color: #000 !important;
	// color: #fff;
	justify-content: flex-start !important;

	&::before {
		opacity: 0;
	}
	.home-cate-logo {
		width: 68px;
		height: 68px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;

		&.singlehome { background-image: url(/images/2.0/icon/singlehome.png); }
		&.townhome { background-image: url(/images/2.0/icon/townhome.png); }
		&.condo { background-image: url(/images/2.0/icon/condo.png); }
		&.shophouse { background-image: url(/images/2.0/icon/shophouse.png); }
	}

	&:hover, &.current-page {
		background-color: #c20000 !important;
		color: #fff;

		& .home-cate-logo {
			&.singlehome { background-image: url(/images/2.0/icon/singlehome_wh.png); }
			&.townhome { background-image: url(/images/2.0/icon/townhome_wh.png); }
			&.condo { background-image: url(/images/2.0/icon/condo_wh.png); }
			&.shophouse { background-image: url(/images/2.0/icon/shophouse_wh.png); }
		}
	}
}
.bg-red-red {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 50%;

		background: rgb(255,255,255);
		background: linear-gradient(180deg, rgba(157,30,37,1) 0%,rgba(157,30,37,1) 60%, rgba(255,255,255,1) 60%, rgba(255,255,255,1) 100%);
	}
}
.property-recommend > div {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		background: rgb(237,28,36);
		background: linear-gradient(180deg, rgba(157,30,37,1) 0%, rgba(157,30,37,1) 60%, rgba(237,28,36,1) 60%, rgba(237,28,36,1) 100%);
		position: absolute;
		width: 9%;
		left: -8%;
		top: 0;
		bottom: 0;
	}
}
h2.property-sample {
	a {
		text-decoration: none;
		color: rgba(0, 0, 0, 0.87);
	}
}
.area:hover {
	background-color: #3a3a3a;
	color: #fff;
}
.area-content ::v-deep {
	background-color: #e0e0e0 !important;
	border-top: solid 3px rgb(237,28,36);

	.v-expansion-panel {
		background-color: transparent;
		button {
			padding-left: 0;

			span {
				text-decoration: underline;
				color: rgb(237,28,36);
				max-width: fit-content;
			}
			.v-expansion-panel-header__icon {
				margin-left: 5px;
			}
			&.v-expansion-panel-header--active {
				display: none;
			}
		}
		.v-expansion-panel-content__wrap {
			padding: 0;
		}
	}
}
</style>
